/* eslint-disable @typescript-eslint/ban-types */
import { alias, custom, deserialize, serializable } from 'serializr';
import { Application } from './application.model';
import { PageObject } from './page-object.model';
import { Base } from './base.model';

export class ApplicationVersion extends Base implements PageObject {
  @serializable
  public applicationId: number;
  @serializable(alias('versionName'))
  public name: string;
  @serializable
  public description: string;
  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public startTime: Date;
  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public endTime: Date;
  @serializable(
    custom(
      (v) => {
        if (v) return v.serialize();
      },
      (v) => {
        if (v) return new Application().deserialize(v);
      },
    ),
  )
  public application: Application;
  @serializable
  public versionName: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(ApplicationVersion, input));
  }
}
